// src/components/layout/AdminHeader.jsx
import React from "react";
import AdminPortalHeader from "./AdminPortalHeader";

const AdminHeader = ({ onMenuToggle }) => (
  <AdminPortalHeader
    onMenuToggle={onMenuToggle}
    roleLabel="Hospital Admin"
    profilePath="/admin/profile"
    settingsPath="/admin/settings"
    activityLogPath="/admin/activity-log"
  />
);

export default AdminHeader;
